export const orderTags = (tags: string[]) => {
  return tags.sort((a, b) => a.localeCompare(b));
};
